import { useLocation } from "react-router-dom";
import QueryParameters from "../api/QueryParameters";
import "./ThankYou.css";

interface ThankYouLabel {
  label: string;
  buttonLabel: string;
  buttonUrl: string;
}

export function buildThankYouUrl(queryParams: QueryParameters) {
  return { pathname: "/thankyou", search: queryParams.buildUrlParamsForTelemetry() };
}

export default function ThankYou() {
  const location = useLocation<ThankYouLabel>();

  const onClickHandler = () => {
    if (location.state.buttonUrl && location.state.buttonUrl.length !== 0) {
      window.location.href = location.state.buttonUrl;
    } else {
      window.location.href = "https://www.unilever.com";
    }
  };

  return (
    <div className="thank-you">
      <p>{location.state?.label}</p>
      <button className="confirm-button" type="button" onClick={onClickHandler}>
        {location.state?.buttonLabel}
      </button>
    </div>
  );
}
